import { PreferredLocation } from '../interfaces/prefferedLocation';
import { RigidTrailerType, TrailerType } from '../enums/TrailerType';
import { TruckType } from '../enums/TruckType';
import { Tenant } from '../interfaces/tenant';
import { ExternalLiveLoadMapping } from './ExternalLiveLoadMapping';

export enum VehicleAtLocationLoadingStatus {
  available = 'available',
  loadingStarted = 'loading-started',
  loadingFinished = 'loading-finished',
  pgiCompleted = 'pgi-completed',
  // TODO uncomment if there is need for departed status to be shown
  // departed = 'departed',
}

type TrailerWithRigid = TrailerType | RigidTrailerType;
export type VehicleAtLocation = {
  id?: string;
  preferredLocation?: PreferredLocation;
  vehicleType: TruckType | TrailerType;
  registration: string;
  driver: string;
  // TODO change type of inspectionResult according to documentation from Apollo https://saturnf1.atlassian.net/browse/ZS-1507
  inspectionResult: string;
  gateIn: Date;
  status: VehicleAtLocationLoadingStatus;
  parkingSpot?: string;
  haulier?: Tenant;
  externalLiveLoadsMapping?: ExternalLiveLoadMapping;
};
